<ng-container *ngIf="activeUser$ | async"></ng-container>

<app-public-layout-wrapper>
  <div leftside class="container-side-left">
    <app-button
      class="ind-btn-wrapper-100"
      type="submit"
      label="buttons.labels.signin"
      [routerLink]="loginPath"
      className="ind-btn ind-btn--secondary"></app-button>
  </div>
  <ng-container rightside>
    <app-header-public> </app-header-public>

    <div *ngIf="activationState === 'PENDING'" class="active_pending">
      <mat-icon class="active_pending__mat-icon">update</mat-icon>
    </div>

    <app-account-activated *ngIf="activationState === 'ACTIVATED'"></app-account-activated>

    <app-activation-link-expired
      *ngIf="activationState === 'TOKEN_EXPIRED'"
      (resendVerificationLink)="onOpenResendVerificationLinkForm()">
    </app-activation-link-expired>

    <app-resend-verification-link-form
      *ngIf="activationState === 'RESEND_ACTIVATION_LINK'"
      (resendVerificationLink)="onResendVerificationLink($event)">
    </app-resend-verification-link-form>

    <app-verifying-email
      *ngIf="activationState === 'VERIFYING_EMAIL'"
      [email]="email"></app-verifying-email>

    <app-sign-in-mobile-footer></app-sign-in-mobile-footer>
  </ng-container>
</app-public-layout-wrapper>
